if (!customElements.get('ajax-sort')) {
  class AjaxSort extends HTMLElement {
    constructor() {
      super();

      this.handlerRef = this.handleChange.bind(this);
    }

    handleChange(event) {
      const url = window.location.href + '?sort_by=' + event.target.value;

      document.dispatchEvent(new CustomEvent('alexa:update-collection-grid', { detail: { url } }));
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handlerRef);
    }

    connectedCallback() {
      this.addEventListener('change', this.handlerRef);
    }
  }
  customElements.define('ajax-sort', AjaxSort);
}
